import React from "react";
import { FIELD_TYPES } from "../core/constants";

/** Renders admin-defined custom fields for an entity form. */
export function CustomFieldInputs({ fields = [], values = {}, onChange, grid = true }) {
  if (!fields.length) return null;
  const set = (id, val) => onChange({ ...values, [id]: val });
  const wrap = grid ? "form-grid-2" : "";

  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: "var(--navy)", marginBottom: 10 }}>Additional Fields</div>
      <div className={wrap}>
        {fields.map(f => (
          <div key={f.id} className="f-group" style={f.type === "textarea" ? { gridColumn: grid ? "1 / -1" : undefined } : undefined}>
            <label className="f-label">{f.label}{f.required ? " *" : ""}</label>
            {f.type === "select" ? (
              <select className="f-select" value={values[f.id] || ""} onChange={e => set(f.id, e.target.value)}>
                <option value="">Select…</option>
                {(f.options || "").split(",").map(o => o.trim()).filter(Boolean).map(o => (
                  <option key={o} value={o}>{o}</option>
                ))}
              </select>
            ) : f.type === "textarea" ? (
              <textarea className="f-textarea" rows={3} value={values[f.id] || ""} onChange={e => set(f.id, e.target.value)} />
            ) : (
              <input
                className="f-input"
                type={f.type === "number" ? "number" : f.type === "date" ? "date" : f.type === "email" ? "email" : f.type === "tel" ? "tel" : "text"}
                value={values[f.id] || ""}
                onChange={e => set(f.id, e.target.value)}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export function CustomFieldDisplay({ fields = [], values = {} }) {
  const rows = (fields || []).filter(f => values?.[f.id]);
  if (!rows.length) return null;
  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: "var(--muted)", textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 8 }}>Additional Information</div>
      <div className="form-grid-2">
        {rows.map(f => (
          <div key={f.id} className="f-group">
            <label className="f-label">{f.label}</label>
            <div style={{ fontSize: 13, fontWeight: 500, padding: "8px 10px", background: "#F9FAFB", borderRadius: 6, border: "1px solid var(--border)" }}>
              {values[f.id]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
